import { ExtendedDosage } from '~libs.shared.prescription';

import { useFormatStages } from './ExtendedDosageStagesList.hooks';
import { StyledExtendedDosageStagesList, StyledExtendedDosageStagesListItem } from './ExtendedDosageStagesList.styled';

type ExtendedDosageStagesListProps = {
   readonly stages: ExtendedDosage['stages'];
   readonly portionUnit?: ExtendedDosage['portionUnit'] | null;
};

export const ExtendedDosageStagesList = (props: ExtendedDosageStagesListProps): JSX.Element => {
   const formatStages = useFormatStages();

   return (
      <StyledExtendedDosageStagesList>
         {formatStages(props.stages, props.portionUnit).map((formattedStage, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <StyledExtendedDosageStagesListItem key={index}>{formattedStage}</StyledExtendedDosageStagesListItem>
         ))}
      </StyledExtendedDosageStagesList>
   );
};
